import React, { useState } from 'react';
import Icon from './Icon';
import { getFingerprint } from '../../utils/fingerprint';
import { API } from '../../utils/api';
import { fmtDate } from '../../utils/format';
import { avatarGradient } from '../../utils/avatar';

const EMOJIS = { fire: '🔥', heart: '❤️', eye: '👀', sparkle: '✨' };

function AvatarBubble({ name, size = 32 }) {
    const letter1 = (name || '?')[0].toUpperCase();
    return (
        <div style={{
            width: size, height: size, borderRadius: '50%', flexShrink: 0,
            background: avatarGradient(name),
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: size * 0.42, fontWeight: 700,
        }}>{letter1}</div>
    );
}

export default function CommentItem({ comment }) {
    const [counts, setCounts] = useState(comment.reactions ?? {});
    const [mine, setMine]     = useState(comment.my_reaction ?? null);

    const toggle = async (type) => {
        const fp      = getFingerprint();
        const isOn    = mine === type;
        const newMine = isOn ? null : type;

        setCounts(prev => {
            const next = { ...prev };
            if (isOn) next[type] = Math.max(0, (next[type] || 0) - 1);
            else {
                if (mine) next[mine] = Math.max(0, (next[mine] || 0) - 1);
                next[type] = (next[type] || 0) + 1;
            }
            return next;
        });
        setMine(newMine);

        try {
            const res = await fetch(`${API}/comment_reactions.php?comment_id=${comment.id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ reaction_type: type, fingerprint: fp }),
            });
            const data = await res.json();
            if (data.counts) setCounts(data.counts);
        } catch {}
    };

    const displayedReactions = Object.entries(EMOJIS).filter(([k]) => (counts[k] || 0) > 0);

    return (
        <div style={{ display: 'flex', gap: 10 }}>
            <AvatarBubble name={comment.username} size={32} />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4, fontSize: 12 }}>
                    <span style={{ color: '#fff', fontWeight: 600 }}>{comment.username}</span>
                    <span style={{
                        color: '#52525B',
                        fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
                    }}>
                        {fmtDate(comment.created_at)}
                    </span>
                </div>
                <p style={{ fontSize: 13, color: '#D4D4D8', lineHeight: 1.55, margin: 0 }}>
                    {comment.content}
                </p>
                <div style={{ marginTop: 8, display: 'flex', gap: 4, flexWrap: 'wrap', alignItems: 'center' }}>
                    {displayedReactions.map(([k, emoji]) => {
                        const on = mine === k;
                        return (
                            <button key={k} onClick={() => toggle(k)} style={{
                                display: 'inline-flex', alignItems: 'center', gap: 4,
                                padding: '3px 8px',
                                background: on ? 'rgba(230,0,115,0.13)' : 'transparent',
                                border: `1px solid ${on ? '#e60073' : '#27272A'}`,
                                borderRadius: 999, fontSize: 11,
                                color: on ? '#e60073' : '#A1A1AA', cursor: 'pointer',
                            }}>
                                <span>{emoji}</span>
                                <span style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                                    {counts[k]}
                                </span>
                            </button>
                        );
                    })}
                    <button onClick={() => toggle('fire')} style={{
                        padding: '3px 8px', background: 'transparent',
                        border: '1px dashed #27272A', borderRadius: 999,
                        fontSize: 11, color: '#71717A', cursor: 'pointer',
                        display: 'flex', alignItems: 'center', gap: 2,
                    }}>
                        <Icon name="plus" size={11} color="#71717A" stroke={2} />
                    </button>
                </div>
            </div>
        </div>
    );
}
